import { render, staticRenderFns } from "./gallery.vue?vue&type=template&id=7ff49a6a&scoped=true&"
import script from "./gallery.vue?vue&type=script&lang=js&"
export * from "./gallery.vue?vue&type=script&lang=js&"
import style0 from "./gallery.vue?vue&type=style&index=0&id=7ff49a6a&lang=scss&scoped=true&"
import style1 from "./gallery.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff49a6a",
  null
  
)

export default component.exports